// Fetch the React panel (widget-panel.js) from the loader's own origin with a
// plain <script> tag, so customers keep pasting one URL and a strict CSP only
// needs the Echo host in `script-src`. The panel bundle registers itself on
// `window.__aevoEchoPanel` when it runs.

import { PANEL_GLOBAL, type PanelModule } from './panel-contract'

let pending: Promise<PanelModule> | null = null

// The nonce of the script that loaded us, for hosts with a nonce-based CSP.
const bootNonce =
  typeof document !== 'undefined'
    ? ((document.currentScript as HTMLScriptElement | null)?.nonce ?? '')
    : ''

export function loadPanelScript(url: string): Promise<PanelModule> {
  const existing = window[PANEL_GLOBAL]
  if (existing) return Promise.resolve(existing)
  if (pending) return pending
  pending = new Promise<PanelModule>((resolve, reject) => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    if (bootNonce) script.nonce = bootNonce
    script.onload = () => {
      const mod = window[PANEL_GLOBAL]
      if (mod) resolve(mod)
      else {
        pending = null
        reject(new Error('[aevo-echo] widget-panel.js loaded but did not register'))
      }
    }
    script.onerror = () => {
      pending = null
      script.remove()
      reject(new Error(`[aevo-echo] could not load ${url}`))
    }
    document.head.appendChild(script)
  })
  return pending
}
